import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getDate } from '../../utils/dateUtil';
import { WEEK_KOR_STR } from '../../utils/constants';
import HelpModal from '../HelpModal/HelpModal';
import { MainContainer } from './Main.styles';

const Main = () => {
    let navigate = useNavigate();
    const [today, setToday] = useState("");
    const [showHelp, setShowHelp] = useState(false);

    useEffect(() => {
        window.gtag("event", "Page_메인");

        var now = new Date();
        let day = getDate();
        setToday(WEEK_KOR_STR[now.getDay()] + "요일 " + parseInt(day.substring(4, 6)) + "." + parseInt(day.substring(6)));

        if (window.location.href.indexOf("go=main") === -1) {
            let list = JSON.parse(localStorage.getItem("plan"));
            if (list && list.length > 0) {
                navigate("/weather.html");
            }
        }
    }, []);

    return (
        <MainContainer>
            <button className='helpBtn' onClick={() => setShowHelp(true)}>?</button>
            <div className='title'>
                <label>MICRO WEATHER</label><br />
                <label className='todayLb'>{today}</label><br />
            </div>
            <div className='mainDiv'>
                <Link to="/plan.html" className='menuBtn'>
                    <div>
                        <span>일정</span> <span>Schedule</span>
                    </div>
                </Link>
                <Link to="/weather.html" className="menuBtn">
                    <div>
                        <span>예보</span> <span>Casting</span>
                    </div>
                </Link>
                <Link to="/today.html" className="menuBtn">
                    <div>
                        <span>오늘</span> <span>Today</span>
                    </div>
                </Link>
            </div>
            <h3 className='bottomLb1'>개인 맞춤형 날씨 예보</h3>
            <h3 className='bottomLb2'>Personalized Weather Forecast</h3>
            <a href="mailto:nightkms@gmail.com" className='about'>contact us</a>

            {showHelp &&
                <HelpModal page="default" onClose={() => setShowHelp(false)} />
            }
        </MainContainer>
    );
};

export default Main;
